'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = init;

var _listeners = require('../utils/listeners');

var _reactiveState = require('../utils/reactive-state');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollDirections = {
  DOWN: 'DOWN',
  UP: 'UP'
};

function init(_ref) {
  var _triggerPoints;

  var el = _ref.el,
      context = _ref.context;

  var headerFilled = 'hd-Header-filled';
  var headerDirection = 'hd-Header-direction';

  var options = {
    safeArea: 100,
    triggerPoints: (_triggerPoints = {}, (0, _defineProperty3.default)(_triggerPoints, ScrollDirections.DOWN, 150), (0, _defineProperty3.default)(_triggerPoints, ScrollDirections.UP, -150), _triggerPoints)
  };

  var state = new _reactiveState.ReactiveState({
    isHidden: false,
    scrollDirection: null
  });

  state.subscribe('isHidden', onIsHiddenChange);
  state.subscribe('scrollDirection', onScrollDirectionChange);

  var listeners = new _listeners.Listeners();
  listeners.add(window, 'scroll', onScroll);

  var isTicking = false;
  var lastKnownY = window.pageYOffset;
  var startPoint = void 0;
  var triggerPoint = void 0;

  function onScroll() {
    state.scrollDirection = window.pageYOffset >= lastKnownY ? ScrollDirections.DOWN : ScrollDirections.UP;

    lastKnownY = window.pageYOffset;

    requestTick();
  }

  function requestTick() {
    if (!isTicking) window.requestAnimationFrame(updateEl);

    isTicking = true;
  }

  function updateEl() {
    isTicking = false;

    var startedScrolling = lastKnownY > 1;

    el.classList.toggle(headerFilled, startedScrolling);

    state.isHidden = function () {
      if (lastKnownY > options.safeArea) {
        if (state.scrollDirection === ScrollDirections.DOWN) {
          var scrollIsBetweenStartAndTriggerPoint = startPoint <= lastKnownY && lastKnownY < triggerPoint;
          var scrollIsAfterTriggerPoint = lastKnownY >= triggerPoint;

          if (scrollIsBetweenStartAndTriggerPoint) {
            return false;
          }

          if (scrollIsAfterTriggerPoint) {
            return true;
          }
        }

        if (state.scrollDirection === ScrollDirections.UP) {
          var scrollIsBeforeTriggerPoint = lastKnownY > triggerPoint;
          var _scrollIsAfterTriggerPoint = lastKnownY <= triggerPoint;

          if (scrollIsBeforeTriggerPoint) {
            return true;
          }

          if (_scrollIsAfterTriggerPoint) {
            return false;
          }
        }
      } else {
        return false;
      }
    }();
  }

  function onIsHiddenChange(value) {
    el.classList.toggle(headerDirection, value);
  }

  function onScrollDirectionChange(value, _ref2) {
    var prevVal = _ref2.prevVal;

    var directionHasChanged = value !== prevVal;

    if (directionHasChanged) {
      startPoint = lastKnownY;
      triggerPoint = startPoint + options.triggerPoints[value];
    }
  }
}